import differenceInSeconds from 'date-fns/differenceInSeconds';
import _format from 'date-fns/format';
import startOfMonth from 'date-fns/startOfMonth';
import startOfToday from 'date-fns/startOfToday';
import startOfYesterday from 'date-fns/startOfYesterday';
import parseJSON from 'date-fns/parseJSON';
import _ from 'lodash';

const format = (
  date: Date | string | number,
  format: string = 'MMM dd, yyyy',
  options?: any,
): string => {
  return _format(parseJSON(date), format, options);
};

const fullDate = (date: string, options?: any): string => {
  return format(date, 'HH:mm MMM dd, yyyy', options);
};

const today = (dateFormat: string): string => {
  return format(startOfToday(), dateFormat);
};

const yesterday = (dateFormat: string): string => {
  return format(startOfYesterday(), dateFormat);
};

const firstDayOfMonth = (dateFormat: string): string => {
  return format(startOfMonth(startOfToday()), dateFormat);
};

const getDifferenceWithNowInSeconds = (dateUtc: string): number => {
  const nowUtc = new Date().getTime();
  const diff = differenceInSeconds(nowUtc, parseJSON(dateUtc));

  return _.round(Math.abs(diff));
};

export {
  format,
  fullDate,
  today,
  yesterday,
  firstDayOfMonth,
  getDifferenceWithNowInSeconds,
};
